import React, { useContext } from 'react';
import SidebarToggleHandler from '../../../../../@coremat/CmtLayouts/Vertical/SidebarToggleHandler';
import Toolbar from '@material-ui/core/Toolbar';
import { Box, IconButton, InputBase, Tooltip } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';
import LanguageSwitcher from '../LanguageSwitcher';
import makeStyles from '@material-ui/core/styles/makeStyles';
import SearchIcon from '@material-ui/icons/Search';
import AppsMenu from './AppsMenu';
import HeaderNotifications from './HeaderNotifications';
import HeaderMessages from './HeaderMessages';
import Hidden from '@material-ui/core/Hidden';
import Logo from '../Logo';
import SearchPopover from '../SearchPopover';
import LayoutContext from '@coremat/CmtLayouts/LayoutContext';
import { runtime } from '@codeArt/common';
import RemoveIcon from '@material-ui/icons/Remove';
import CropSquareIcon from '@material-ui/icons/CropSquare';
import CloseIcon from '@material-ui/icons/Close';
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import { send,listen, on, off } from '@codeArt/electron/renderer/ipc';
import { close as closeWindow, get as getWindowInfo } from "@codeArt/electron/renderer/window";
import AppContext from '@jumbo/components/contextProvider/AppContextProvider/AppContext';
import { AsyncComponent } from '@codeArt/components/common';


const useStyles = makeStyles(theme => ({
  root:({headerDraggable})=>({
    width: '100%',
    paddingLeft: 16,
    paddingRight: 16,
    minHeight: 64,
    [theme.breakpoints.up('md')]: {
      minHeight: 72,
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: 24,
      paddingRight: 24,
    },
    ...runtime.electron && headerDraggable!==false?{
      "-webkit-app-region":"drag"
    }:null
  }),
  searchRoot: {
    position: 'relative',
    width: 260,
    [theme.breakpoints.up('md')]: {
      width: 350,
    },
    '& .MuiSvgIcon-root': {
      position: 'absolute',
      left: 18,
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 1,
    },
    '& .MuiInputBase-root': {
      width: '100%',
    },
    '& .MuiInputBase-input': {
      height: 48,
      borderRadius: 30,
      backgroundColor: alpha(theme.palette.common.dark, 0.38),
      color: alpha(theme.palette.common.white, 0.7),
      boxSizing: 'border-box',
      padding: '5px 15px 5px 50px',
      transition: 'all 0.3s ease',
      '&:focus': {
        backgroundColor: alpha(theme.palette.common.dark, 0.58),
        color: alpha(theme.palette.common.white, 0.7),
      },
    },
  },
  langRoot: {
    borderLeft: `solid 1px ${alpha(theme.palette.common.dark, 0.15)}`,
    minHeight: 72,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: 8,
    paddingRight: 8,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      minHeight: 64,
    },
  },
  iconBtn: {
    color: alpha(theme.palette.common.white, 0.38),
    '&:hover, &:focus': {
      color: theme.palette.common.white,
    },
  },
  noDrag:{
    "-webkit-app-region":"no-drag",
    "-webkit-user-select": "none"
  },
  windowTool:{
    display:"flex",
    flexDirection: "row"
  }
}));


const Header = () => {
  const {
    sidebarType,
  } = useContext(LayoutContext);

  const {
    headerComponent,
    headerBoxComponent,
    headerToolComponent,
    headerDraggable,
  } = useContext(AppContext);

  const classes = useStyles({headerDraggable});

  if(headerComponent) return headerComponent;

  const renderTool = ()=>{
    if(headerToolComponent) return <Box className={classes.noDrag}>{headerToolComponent}</Box>;
    return runtime.electron?<Box className={classes.noDrag}><WindowTool /></Box>:null;
  }

  return (
    <Toolbar className={classes.root}>
      {sidebarType==="hidden"?null:<SidebarToggleHandler edge="start" color="inherit" aria-label="menu" />}
      <Logo ml={2} color="white" />
      <Box flex={1}>
        {headerBoxComponent}
      </Box>
      {/* {renderTool()} */}
    </Toolbar>
  );
};


const WindowToolBody = (function (){
  
  const Minimize =({winId})=>{
    const classes = useStyles();
    function handleClick(){
      send("sys:minimizeWindow",{winId});
    }

    return <Tooltip title="最小化">
      <IconButton className={classes.iconBtn} onClick={()=>{ handleClick(); }}>
        <RemoveIcon />
      </IconButton>
    </Tooltip>
  }

  const Maximize =({winId})=>{
    const classes = useStyles();
    function handleClick(){
      send("sys:maximizeWindow",{winId});
    }

    return <Tooltip title="最大化">
      <IconButton className={classes.iconBtn} onClick={()=>{ handleClick(); }}>
        <CropSquareIcon />
      </IconButton>
    </Tooltip>
  }

  const Close =({winId})=>{
    const classes = useStyles();
    function handleClick(){
      closeWindow();
    }

    return <Tooltip title="关闭">
      <IconButton className={classes.iconBtn}  onClick={()=>{ handleClick(); }}>
        <CloseIcon />
      </IconButton>
    </Tooltip>
  }

  

  const Restore =({winId})=>{
    const classes = useStyles();

    function handleClick(){
      send("sys:restoreWindow",{winId});
    }

    return <Tooltip title="还原">
      <IconButton className={classes.iconBtn}  onClick={()=>{ handleClick(); }}>
        <FilterNoneIcon />
      </IconButton>
    </Tooltip>
  }

  const Body =({maximize,winId,maxable,minable,restable,closeable})=>{
    const classes = useStyles();

     return <div className={classes.windowTool}>
        {minable!==false?<Minimize winId={winId} />:null}
        {!maximize && maxable!==false?<Maximize winId={winId} />:null}
        {maximize && restable !==false ?<Restore winId={winId} />:null}
        {closeable!==false?<Close winId={winId} />:null}
      </div>
  }

  return Body;

})();


export class WindowTool extends AsyncComponent {

  constructor(props) {
    super(props);
    this.state={
      maximize:false
    }
  }

  componentDidMount(){

    getWindowInfo().then(({isMaxSize})=>{
      this.setState({
        maximize:isMaxSize
      });
    });

    on("sys:onWindowResize.windowTool",({id,isMaxSize})=>{
      if(runtime.electron.winId !== id) return; //防止多窗口下冲突
      this.setState({
        maximize:isMaxSize
      });
    })
  }

  componentWillUnmount(){
    super.componentWillUnmount();
    off("sys:onWindowResize.windowTool");
  }

  render(){
    let {maximize} = this.state;
    let {maxable,minable,restable,closeable} = this.props;
    return (
      <WindowToolBody maximize={maximize} winId={runtime.electron.winId} {...{maxable,minable,restable,closeable}} />
    );
  }

}


export default Header;
